import './App.css';
import CacheBuster from './CacheBuster';
import Main from './components/Main';

function App() {
  return (
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
          if (loading) return null;
          if (!loading && !isLatestVersion) {
            refreshCacheAndReload();
            // setTimeout(()=>window.location.reload(true), 2000);
            // setTimeout(()=console.log("prova"), 3000);
          }

          return (
            <Main/>
          );
        }}
    </CacheBuster>
  );
}

export default App;
